import { observer } from "mobx-react-lite";
import {
  createContext,
  type PropsWithChildren,
  useContext,
  useState,
} from "react";

export function makeStoreContext<T extends object, I extends object>(
  storeCls: new (init: I) => T,
) {
  const context = createContext<{ store: T }>(null!);

  function useStoreContext() {
    return useContext(context);
  }

  function useStore() {
    return useStoreContext().store;
  }

  function StoreProvider(props: PropsWithChildren<I>) {
    const { children, ...init } = props;
    const [store] = useState(() => {
      return { store: new storeCls(init as I) };
    });
    return <context.Provider value={store}>{children}</context.Provider>;
  }

  return [observer(StoreProvider), useStoreContext, useStore] as const;
}
